/** 景洪工艺流程图：基准点位（百分比坐标系） */

export const ORIGINAL_IMAGE_SIZE = {
  width: 9999,
  height: 7539
};

export const pctToAnchorPx = (pct) => ({
  x: (pct.x / 100) * ORIGINAL_IMAGE_SIZE.width,
  y: (pct.y / 100) * ORIGINAL_IMAGE_SIZE.height
});

export const anchorPxToPositionPct = (ax, ay) => ({
  x: Math.round((ax / ORIGINAL_IMAGE_SIZE.width) * 1e6) / 1e4,
  y: Math.round((ay / ORIGINAL_IMAGE_SIZE.height) * 1e6) / 1e4
});

export const JH_BASE_VARIABLE_DEFS = [
  { id: 'FT01', label: '一级反硝化池瞬时流量 FT01', name: 'FT01', positionPct: { x: 43.3, y: 34.8 } },
  { id: 'FT02', label: '一级硝化池瞬时流量 FT02', name: 'FT02', positionPct: { x: 50.5, y: 34.8 } },
  { id: 'AT-PH01', label: '一级硝化池pH值 AT-PH01', name: 'AT-PH01', positionPct: { x: 50.5, y: 38.4 } },
  { id: 'AT-DO01', label: '一级硝化池溶解氧 AT-DO01', name: 'AT-DO01', positionPct: { x: 50.5, y: 41.4 } },
  { id: 'DENO2-FLOW', label: '二级反硝化池瞬时流量', name: '', positionPct: { x: 58.0, y: 34.8 } },
  { id: 'DENO2-PH', label: '二级反硝化池pH值', name: '', positionPct: { x: 58.0, y: 38.4 } },
  { id: 'FT03', label: '二级硝化池瞬时流量 FT03', name: 'FT03', positionPct: { x: 65.7, y: 34.8 } },
  { id: 'AT-PH02', label: '二级硝化池pH值 AT-PH02', name: 'AT-PH02', positionPct: { x: 65.7, y: 38.4 } },
  { id: 'AT-DO02', label: '二级硝化池溶解氧 AT-DO02', name: 'AT-DO02', positionPct: { x: 65.7, y: 41.4 } },
  { id: 'FT10', label: '一级芬顿进水流量 FT10', name: 'FT10', positionPct: { x: 91.4, y: 84.8 } },
  { id: 'AH-PH03', label: '一级芬顿反应区pH值 AH-PH03', name: 'AH-PH03', positionPct: { x: 91.4, y: 88.2 } },
  { id: 'AH-PH04', label: '一级芬顿沉淀区pH值 AH-PH04', name: 'AH-PH04', positionPct: { x: 91.4, y: 91.1 } },
  { id: 'LT08', label: '中间池液位 LT08', name: 'LT08', positionPct: { x: 67.1, y: 85.2 } },
  { id: 'AH-PH05', label: '二级芬顿反应区pH值 AH-PH05', name: 'AH-PH05', positionPct: { x: 60.8, y: 85.2 } },
  { id: 'AH-PH06', label: '二级芬顿沉淀区pH值 AH-PH06', name: 'AH-PH06', positionPct: { x: 60.8, y: 88.1 } },
  { id: 'LT03', label: '清水池液位 LT03', name: 'LT03', positionPct: { x: 39.2, y: 90.0 } }
];

export const mergeSavedPositions = (baseDefs, positions) => {
  const list = Array.isArray(positions) ? positions : [];
  const posById = Object.fromEntries(
    list
      .filter((p) => p && p.id && p.positionPct && typeof p.positionPct.x === 'number')
      .map((p) => [p.id, p.positionPct])
  );
  return baseDefs.map((v) => {
    const pct = posById[v.id] || v.positionPct;
    return {
      ...v,
      positionPct: pct,
      anchorPx: pctToAnchorPx(pct)
    };
  });
};

export const buildDefaultOffsets = (defs) =>
  defs.reduce((acc, item) => {
    acc[item.id] = { x: 0, y: 0 };
    return acc;
  }, {});

export const DRAFT_STORAGE_KEY = 'jh_process_diagram_offset_draft_v1';
